// extracted by mini-css-extract-plugin
module.exports = {"centerbg":"centerView_centerbg__1LOrA","center_box_img":"centerView_center_box_img__3NRyL","hide":"centerView_hide__Z7c-z"};